import { useRef, useState } from 'react';
import Swal from 'sweetalert2';

export default function useOrdenacao(itens, setItens, salvar) {
    const origem = useRef(null);
    const [alterada, setAlterada] = useState(false);
    const [salvando, setSalvando] = useState(false);

    function mover(de, para) {
        if (salvando || de === para || de < 0 || para < 0 || para >= itens.length) return;
        const lista = [...itens];
        lista.splice(para, 0, lista.splice(de, 1)[0]);
        // Mantém as posições disponíveis, inclusive na lista filtrada do produtor.
        const posicoes = itens.map(item => item.ordem);
        setItens(lista.map((item, index) => ({ ...item, ordem: posicoes[index] })));
        setAlterada(true);
    }

    function linha(index) {
        return {
            draggable: !salvando,
            style: { cursor: salvando ? 'wait' : 'grab' },
            onDragStart: event => {
                origem.current = index;
                event.dataTransfer.effectAllowed = 'move';
                event.dataTransfer.setData('text/plain', String(itens[index].id));
            },
            onDragEnd: () => { origem.current = null; },
            onDragOver: event => { if (!salvando) event.preventDefault(); },
            onDrop: event => {
                event.preventDefault();
                if (origem.current !== null) mover(origem.current, index);
                origem.current = null;
            }
        };
    }

    function controleOrdem(index) {
        return {
            onKeyDown: event => {
                if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                    event.preventDefault();
                    mover(index, index + (event.key === 'ArrowUp' ? -1 : 1));
                }
            }
        };
    }

    async function atualizar() {
        setSalvando(true);
        try {
            const user = JSON.parse(localStorage.getItem('userd7'));
            const resultado = await salvar({ id: user.id, perfil: user.perfil, ids: itens.map(item => item.id) });
            setItens(resultado.itens);
            setAlterada(false);
            Swal.fire('Sucesso', 'Ordem atualizada com sucesso.', 'success');
        } catch (error) {
            Swal.fire('Erro', error.message || 'Não foi possível atualizar a ordem.', 'error');
        } finally {
            setSalvando(false);
        }
    }

    return { linha, controleOrdem, atualizar, alterada, salvando, redefinir: () => setAlterada(false) };
}
